import { Button, Inline, Stack, Text } from 'braid-design-system';
import { useNavigate, useParams } from 'react-router';

export const SalariesPageContainer = () => {
  const params = useParams();
  const navigate = useNavigate();

  const isSalariesHubRoute = params.roleAlias === undefined;

  return (
    <Stack space="large">
      <Inline space="small" collapseBelow="desktop">
        <Button
          onClick={() => navigate(`/companies/${params.companySlug}/salaries`)}
        >
          Salary Hub
        </Button>
        <Button
          onClick={() =>
            navigate(`/companies/${params.companySlug}/salaries/role-alias`)
          }
        >
          Aggregated Salary Page
        </Button>
      </Inline>
      {isSalariesHubRoute ? (
        <Text>Salary Hub In Progress</Text>
      ) : (
        <Text>Aggregated Salary Page Work In Progress</Text>
      )}
    </Stack>
  );
};
